module.exports = __webpack_public_path__ + "assets/img/typeIcon-3-yellow.3e22edc6.svg";